/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, withStyles } from "@material-ui/core";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

function Footer({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
          <ListItem className={classes.inlineBlock}>
              <a
                href="https://www.oneclass.com.tw"
                className={classes.block}
                target="_blank"
              >
                OneClass
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="https://trans.nani.com.tw/NaniWeb/"
                className={classes.block}
                target="_blank"
              >
                南一書局
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="https://trans.nani.com.tw/NaniTeacher/"
                className={classes.block}
                target="_blank"
              >
                教師網
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="https://tks.nani.com.tw/"
                className={classes.block}
                target="_blank"
              >
                雲端出題
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="http://kids.nani.com.tw/"
                className={classes.block}
                target="_blank"
              >
                幼教網
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="https://goo.gl/WJ6ucS"
                className={classes.block}
                target="_blank"
              >
                
              </a>
            </ListItem>
          </List>
        </div>
        <div className={classes.right}>
          &copy; {1900 + new Date().getYear()} ,
          Made with Copyright © NANI BOOK ENTERPRISE CO.,LTD. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/Footer/Footer.jsx